import React from "react";

import {useQuery} from "@tanstack/react-query";

import {useSiteConfig} from "@globals/SiteConfig";

import LoadingDots from "@components/LoadingDots";
import SupportEmail from "@components/SupportEmail";

import styles from "./AllergenNotice.scss";

type AllergenNoticeProps = {
  tenantSlug: string;
};

export default function AllergenNotice({
  tenantSlug,
}: AllergenNoticeProps): JSX.Element {
  const {getAllergenOverride} = useSiteConfig();
  const {
    data: allergenOverride,
    isPending: isLoading,
    isError,
  } = useQuery({
    queryKey: ["allergen-override"],
    queryFn: () => getAllergenOverride(tenantSlug),
  });

  return (
    <div>
      {isLoading && <LoadingDots />}
      {isError && (
        <>
          Sorry, we couldn't load the allergen notice. Please try refreshing, or
          contact Customer Support if you have any questions.
        </>
      )}
      {!isLoading &&
        !isError &&
        (allergenOverride ? (
          <>{allergenOverride}</>
        ) : (
          <>
            Be aware that we handle and prepare egg, milk, wheat, shellfish,
            fish, soy, sesame, peanut and tree nut products, and other potential
            allergens in the food production areas of our facility. Contact us
            at <SupportEmail className={styles.contactLink} isLink /> with
            questions.
          </>
        ))}
    </div>
  );
}
